import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import ButtonFlat from '../../base/ButtonFlat/ButtonFlat.js';
import Icon from '../../base/Icon/Icon.js';
import Translate from '../../base/Translate/Translate.js';

import { IToastConfiguration, IToastProps, IToastState } from './models/index.js';
import { ToastType } from './models/ToastType.js';
import Close from './styledComponents/Close.js';
import ErrorToast from './styledComponents/Error.js';
import InfoToast from './styledComponents/Info.js';
import SuccessToast from './styledComponents/Success.js';
import Text from './styledComponents/Text.js';
import WarningToast from './styledComponents/Warning.js';
import Wrapper from './styledComponents/Wrapper.js';
import { TOAST_CATEGORY_KEY, TOAST_COMPONENT_KEY } from './Toast.meta.js';

export class Toast extends ComponentBase<IToastProps, IToastState, IToastConfiguration> {
	categoryKey = TOAST_CATEGORY_KEY;
	componentKey = TOAST_COMPONENT_KEY;

	constructor(props: IToastProps) {
		super(props);
	}
	getComponentFromType = (type: ToastType) => {
		switch (type) {
			case ToastType.error:
				return ErrorToast;
			case ToastType.success:
				return SuccessToast;
			case ToastType.warning:
				return WarningToast;
			case ToastType.info:
			default:
				return InfoToast;
		}
	};
	handleClose = () => {
		const { toastId, onClose } = this.props;
		if (onClose) {
			onClose(toastId);
		}
	};
	render() {
		const { className, type = ToastType.info, text, canClose = false } = this.props;
		// eslint-disable-next-line @typescript-eslint/naming-convention
		const ToastComponent = this.getComponentFromType(type);
		return (
			<Wrapper className={className}>
				<ToastComponent>
					<Text>
						<Translate>{text}</Translate>
					</Text>
					{canClose && (
						<Close>
							<ButtonFlat onClick={this.handleClose}>
								<Icon asset={'base.toast.close'} alt={'X'} />
							</ButtonFlat>
						</Close>
					)}
				</ToastComponent>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(Toast), TOAST_CATEGORY_KEY, TOAST_COMPONENT_KEY);
